module.exports = __webpack_public_path__ + "img/harness-detail-page2.3ec9f180.jpg";